import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const tabsSectionStyles = {
  accordion: (): SystemStyleObject<Theme> => ({
    background: "transparent",
    boxShadow: "none",
  }),
  bar: (
    theme: Theme,
    { isActive }: { isActive: boolean },
  ): SystemStyleObject<Theme> => ({
    width: { xs: 8, lg: 12, xl: 16 },
    minWidth: { xs: 8, lg: 12, xl: 16 },
    mr: 3,
    transition: theme.transitions.create(["background-color"]),
    backgroundColor: isActive
      ? theme.palette.secondary.main
      : theme.palette.grey[700],
  }),
  title: (
    theme: Theme,
    { isActive }: { isActive: boolean },
  ): SystemStyleObject<Theme> => ({
    transition: theme.transitions.create(["color"]),
    fontSize: { lg: 38, xl: 44 },

    color: isActive ? theme.palette.secondary.main : theme.palette.grey[700],
  }),
};

export default tabsSectionStyles;
